import { render, staticRenderFns } from "./ChannelDialog.vue?vue&type=template&id=061d49e0"
import script from "./ChannelDialog.vue?vue&type=script&lang=js"
export * from "./ChannelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports